.atm_26_1x778eo{background:white;}
.atm_ge_glywfm.atm_ge_glywfm{list-style-type:none;}
.atm_gi_idpfg4{margin:0;}
.atm_l8_idpfg4{padding:0;}
.atm_mk_stnw88{position:absolute;}
